import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";

const tableHead = ["Sr.", "Employee Id & Name", "Leaves", "Status", "Actions"];

const workHolidays = [
  { date: "2024-08-15", holidayType: "full day" },
  { date: "2024-09-07", holidayType: "full day" },
  { date: "2024-10-02", holidayType: "full day" },
  { date: "2024-10-12", holidayType: "full day" },
  { date: "2024-11-01", holidayType: "full day" },
  { date: "2024-11-02", holidayType: "full day" },
  { date: "2024-11-03", holidayType: "full day" },
  { date: "2024-12-25", holidayType: "full day" }, /// 2024 end
  { date: "2025-01-26", holidayType: "full day" },
  { date: "2025-03-14", holidayType: "full day" },
  { date: "2025-03-30", holidayType: "full day" },
  { date: "2025-05-01", holidayType: "full day" },
  { date: "2025-05-14", holidayType: "half day" },
  { date: "2025-08-15", holidayType: "full day" },
  { date: "2025-08-27", holidayType: "full day" },
  { date: "2025-10-02", holidayType: "full day" },
  { date: "2025-10-21", holidayType: "full day" },
  { date: "2025-10-22", holidayType: "full day" },
  { date: "2025-10-23", holidayType: "full day" },
  { date: "2025-12-25", holidayType: "half day" }, // 2025 end
  { date: "2026-01-26", holidayType: "full day" },
  { date: "2026-02-19", holidayType: "full day" },
  { date: "2026-03-03", holidayType: "full day" },
  { date: "2026-03-19", holidayType: "full day" },
  { date: "2026-05-01", holidayType: "full day" },
  { date: "2026-08-15", holidayType: "full day" },
  { date: "2026-09-14", holidayType: "full day" },
  { date: "2026-10-20", holidayType: "full day" },
  { date: "2026-11-08", holidayType: "full day" },
  { date: "2026-11-11", holidayType: "full day" },
  { date: "2026-12-25", holidayType: "full day" }, // 2026 end
];

const returnCounts = (leave) => {
  let sickLeaves = 0;
  let casualLeaves = 0;
  let approvedLeaves = 0;
  let pendingLeaves = 0;
  let rejectedLeaves = 0;

  const { leavesDetails, ...data } = leave;

  // Create quick holiday lookup
  const holidayMap = new Map(
    workHolidays.map((holiday) => [holiday.date, holiday.holidayType])
  );

  for (const l of leavesDetails) {
    let leaveDays = 0;

    // Half-day leave
    if (l.leaveType === "half day") {
      leaveDays = 0.5;
    }

    // Full-day leave
    else if (l.leaveType === "full day") {
      leaveDays = 1;
    }

    // Multiple-day leave
    else {
      const startDate = new Date(l.leaveStartDate);
      const endDate = new Date(l.leaveEndDate);

      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      let currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        const day = currentDate.getDay();

        // YYYY-MM-DD
        const dateString = [
          currentDate.getFullYear(),
          String(currentDate.getMonth() + 1).padStart(2, "0"),
          String(currentDate.getDate()).padStart(2, "0"),
        ].join("-");

        const holiday = holidayMap.get(dateString);

        // Sunday → do not count
        if (day === 0) {
          currentDate.setDate(currentDate.getDate() + 1);
          continue;
        }

        // Full-day holiday → do not count
        if (holiday?.holidayType === "full day") {
          currentDate.setDate(currentDate.getDate() + 1);
          continue;
        }

        // Half-day holiday → count 0.5
        if (holiday?.holidayType === "half day") {
          leaveDays += 0.5;
        } else {
          // Normal working day
          leaveDays += 1;
        }

        currentDate.setDate(currentDate.getDate() + 1);
      }
    }

    // Leave type
    if (l.leaveReasonType === "casual") {
      casualLeaves += leaveDays;
    } else {
      sickLeaves += leaveDays;
    }

    // Leave status
    if (l.leaveStatus === "approved") {
      approvedLeaves += leaveDays;
    } else if (l.leaveStatus === "pending") {
      pendingLeaves += leaveDays;
    } else if (l.leaveStatus === "rejected") {
      rejectedLeaves += leaveDays;
    }
  }

  return {
    ...data,

    sickLeaves: sickLeaves.toFixed(1),
    casualLeaves: casualLeaves.toFixed(1),

    approvedLeaves: approvedLeaves.toFixed(1),
    pendingLeaves: pendingLeaves.toFixed(1),
    rejectedLeaves: rejectedLeaves.toFixed(1),

    totalLeaves: (approvedLeaves + pendingLeaves + rejectedLeaves).toFixed(1),
  };
};

const LeavesTrackingTable = ({ EX = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/employee-leave-management/view/${id}`);
  };
  const [leaveData, setLeaveData] = useState([]);

  useEffect(() => {
    if (EX.length > 0) {
      let data = [];

      for (let leave of EX) {
        let updatedData = returnCounts(leave);
        data.push(updatedData);
      }
      const sortedData = [...data].sort((a, b) => {
        return b.pendingLeaves - a.pendingLeaves;
      });
      setLeaveData(sortedData);
    }
  }, [EX]);

  return (
    <div className="table-responsive">
      <table className="table table-vcenter card-table">
        <thead>
          <tr>
            {tableHead?.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {leaveData?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;

            return (
              <tr
                key={item?.id}
                style={{
                  backgroundColor:
                    item?.pendingLeaves > 0
                      ? "rgba(255, 61, 7, 0.08)"
                      : "transparent",
                }}
              >
                {/* Sr. */}
                <td className="text-secondary">{Index}</td>
                {/* Employee */}
                <td>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <span className="badge bg-blue-lt">
                      {item?.userId ?? "N/A"}
                    </span>
                    <span className="text-secondary">|</span>
                    <div className="d-flex align-items-center">
                      <div>
                        <div className="fw-bold">
                          {item?.employeeName ?? "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                {/* Leaves */}
                <td>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    {/* Total */}
                    <div className="text-center">
                      <div className="fw-bold">{item?.totalLeaves ?? 0}</div>
                      <div className="text-secondary small">Total</div>
                    </div>

                    <span className="text-secondary">|</span>

                    {/* Sick */}
                    <div className="text-center">
                      <div className="fw-bold text-danger">
                        {item?.sickLeaves ?? 0}
                      </div>
                      <div className="text-secondary small">Sick</div>
                    </div>

                    <span className="text-secondary">|</span>

                    {/* Casual */}
                    <div className="text-center">
                      <div className="fw-bold text-success">
                        {item?.casualLeaves ?? 0}
                      </div>
                      <div className="text-secondary small">Casual</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    {/* Pending */}
                    <div className="text-center">
                      <div className="fw-bold">{item?.pendingLeaves ?? 0}</div>
                      <div className="text-secondary small">Pending</div>
                    </div>

                    <span className="text-secondary">|</span>

                    {/* Rejected */}
                    <div className="text-center">
                      <div className="fw-bold text-danger">
                        {item?.rejectedLeaves ?? 0}
                      </div>
                      <div className="text-secondary small">Rejected</div>
                    </div>

                    <span className="text-secondary">|</span>

                    {/* Approved */}
                    <div className="text-center">
                      <div className="fw-bold text-success">
                        {item?.approvedLeaves ?? 0}
                      </div>
                      <div className="text-secondary small">Approved</div>
                    </div>
                  </div>
                </td>
                {/* Actions */}
                <td>
                  <button
                    className="btn btn-sm px-3 btn-primary"
                    onClick={() => goToView(item.userId)}
                  >
                    <BsArrowRightShort className="me-1" />
                    View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LeavesTrackingTable;
